<!--
 * @Description: 账单复核
 * @Author: 琢磨先生
 * @Date: 2022-11-17 10:37:33
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2023-02-10 11:22:55
-->



<template>
  <el-card class="box">
    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="房间">
        <el-cascader
          :options="huxing_list"
          v-model="query.storeIds"
          clearable
          :props="{ multiple: true }"
          collapse-tags
          collapse-tags-tooltip
          filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item label="月份">
        <el-date-picker v-model="query.month" type="month" value-format="YYYY-MM-01" placeholder></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" round @click="onSearch" icon="search">查询</el-button>
      </el-form-item>
    </el-form>
  </el-card>
  <el-card class="box data" v-loading="loading">
    <el-table :data="tableData" border>
      <el-table-column label="账期"  width="120">
        <template #default="scope">
          <div>{{ scope.row.month_text }}</div>
        </template>
      </el-table-column>
      <el-table-column label="房东" prop="landlord.name" width="140">
        <!-- <template #default="scope">
          <div>{{ scope.row.landlord.name }}</div>
        </template> -->
      </el-table-column>
      <el-table-column label="房号" width="200" prop="house_no"></el-table-column>
      <el-table-column label="营业总额(元)" width="140">
        <template #default="scope">￥{{ scope.row.decimal_total_amount }}</template>
      </el-table-column>
      <el-table-column label="业主分成(元)" width="140">
        <template #default="scope">
          <div>{{ scope.row.decimal_income_rate }}%</div>
          <div>￥{{ scope.row.decimal_landlord_income_amount }}</div>
        </template>
      </el-table-column>
      <el-table-column label="成本(元)" width="120">
        <template #default="scope">￥{{ scope.row.decimal_expense_total_amount }}</template>
      </el-table-column>
      <el-table-column label="实际成本(元)" width="120">
        <template #default="scope">￥{{ scope.row.decimal_actual_expense_total_amount }}</template>
      </el-table-column>
      <el-table-column label="业主成本(元)" width="120">
        <template #default="scope">￥{{ scope.row.decimal_landlord_expense_amount }}</template>
      </el-table-column>
      <el-table-column label="业主净收益(元)" width="120">
        <template #default="scope">￥{{ scope.row.decimal_landlord_profit_amount }}</template>
      </el-table-column>
      <el-table-column label="商户成本" width="120">
        <template #default="scope">￥{{ scope.row.decimal_business_expense_amount }}</template>
      </el-table-column>
      <el-table-column label="商户实际成本" width="120">
        <template #default="scope">￥{{ scope.row.decimal_business_actual_expense_amount }}</template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template #default="scope">
          <!-- <el-tag type="info" size="small">{{ scope.row.status_text }}</el-tag> -->
          <el-tag size="small" type="success" v-if="scope.row.status==40">{{ scope.row.status_text }}</el-tag>
          <el-tag size="small" type="danger" v-else-if="scope.row.status==30">{{ scope.row.status_text }}</el-tag>
          <el-tag size="small" type="warning" v-else-if="scope.row.status==20">{{ scope.row.status_text }}</el-tag>
          <el-tag size="small" v-else-if="scope.row.status==10">{{ scope.row.status_text }}</el-tag>
          <el-tag size="small" type="info" v-else>{{ scope.row.status_text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_at" width="180"></el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template #default="scope">
          <el-button type="primary" link @click="onDtl(scope.row)">详情</el-button>
          <!-- <el-popconfirm
              title="确定要开放确认？"
              @confirm="onOpenConfirm(scope.row)"
              v-if="
                scope.row.status != 20 &&
                scope.row.status != 30 &&
                scope.row.status != 40
              "
            >
              <template #reference>
                <el-button type="primary" link size="small" class="text-danger"
                  >开放确认</el-button
                >
              </template>
          </el-popconfirm>-->
        </template>
      </el-table-column>
    </el-table>
  </el-card>
  <bill-dtl :id="current_id" @close="current_id = null" @success="this.loadData()"></bill-dtl>
</template>
  
  <script>
import BillDtl from "./dtl.vue";
import common_api from "@/http/common_api";
import huxing_api from "@/http/huxing_api";

export default {
  components: {
    BillDtl,
  },
  data() {
    return {
      loading: false,
      //数据
      tableData: [],
      query: {
        order: {
          sort: "",
          fieldName: "",
        },
        q: "",
      },
      //
      enums: {},
      //房型options
      huxing_list: [],
      //当前id
      current_id: "",
    };
  },
  created() {
    common_api.get_enums().then((res) => {
      if (res.code == 0) {
        this.enums = res.data;
      }
    });
    huxing_api.get_cascader().then((res) => {
      if (res.code == 0) {
        this.huxing_list = [];
        res.data.forEach((x) => {
          var model = {
            value: x.id,
            label: x.name,
            children: [],
          };
          x.store_list.forEach((item) => {
            model.children.push({
              value: item.id,
              label: item.house_no,
            });
          });
          this.huxing_list.push(model);
        });
      }
    });
    this.loadData();
  },
  methods: {
    /**
     * 搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },

    /**
     * 加载数据
     */
    loadData() {
      var arg = Object.assign({}, this.query);
      if (
        Array.isArray(this.query.storeIds) &&
        this.query.storeIds.length > 0
      ) {
        arg.store_ids = this.query.storeIds.map((x) => {
          return x[1];
        });
      }
      this.loading = true;
      this.$http
        .post("seller/v1/landlordBill/review", arg)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.tableData = res.data;
          }
        });
    },
    /**
     * 排序
     */
    onSort(e) {
      if (e.prop) {
        this.query.order.sort = e.order;
        this.query.order.fieldName = e.prop;
        this.loadData();
      }
    },

    /**
     *开放确认
     */
    onOpenConfirm(item) {
      this.$http
        .get("seller/v1/landlordBill/openConfirm?id=" + item.id)
        .then((res) => {
          if (res.code == 0) {
            this.loadData();
          }
        });
    },

    /**
     * 查看详情
     */
    onDtl(item) {
      this.current_id = item.id;
    },
  },
};
</script>
  
  <style   scoped>
</style>